module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('admin-layout', [_c('div', {
    staticClass: "content",
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v("User Settings for " + _vm._s(_vm.userModel.email))]), _vm._v(" "), _c('FormulateForm', {
    on: {
      "submit": _vm.save
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hasErrors = ref.hasErrors;

        return [_c('FormulateInput', {
          attrs: {
            "type": "text",
            "label": "First Name",
            "validation": "required"
          },
          model: {
            value: (_vm.userModel.first_name),
            callback: function($$v) {
              _vm.$set(_vm.userModel, "first_name", $$v)
            },
            expression: "userModel.first_name"
          }
        }), _vm._v(" "), _c('FormulateInput', {
          attrs: {
            "type": "text",
            "label": "Last Name",
            "validation": "required"
          },
          model: {
            value: (_vm.userModel.last_name),
            callback: function($$v) {
              _vm.$set(_vm.userModel, "last_name", $$v)
            },
            expression: "userModel.last_name"
          }
        }), _vm._v(" "), _c('FormulateInput', {
          attrs: {
            "type": "submit",
            "disabled": hasErrors,
            "label": "Save"
          }
        })]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v("Change Password")]), _vm._v(" "), _c('FormulateForm', {
    on: {
      "submit": _vm.updatePassword
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hasErrors = ref.hasErrors;

        return [_c('FormulateInput', {
          attrs: {
            "type": "password",
            "label": "Current Password",
            "validation": "required|isValidOldPassword",
            "validation-rules": {
              isValidOldPassword: _vm.isValidOldPassword
            },
            "error-bahavior": "live"
          },
          model: {
            value: (_vm.passwordModel.old_password),
            callback: function($$v) {
              _vm.$set(_vm.passwordModel, "old_password", $$v)
            },
            expression: "passwordModel.old_password"
          }
        }), _vm._v(" "), _c('FormulateInput', {
          attrs: {
            "type": "password",
            "label": "New Password",
            "validation": "required"
          },
          on: {
            "input": function($event) {
              _vm.validPassword = []
            }
          },
          model: {
            value: (_vm.passwordModel.new_password1),
            callback: function($$v) {
              _vm.$set(_vm.passwordModel, "new_password1", $$v)
            },
            expression: "passwordModel.new_password1"
          }
        }), _vm._v(" "), _c('FormulateInput', {
          attrs: {
            "type": "password",
            "error-behavior": "live",
            "label": "Repeat New Password",
            "validation": "required|samePassword|isValidPassword",
            "validation-rules": {
              samePassword: _vm.samePassword,
              isValidPassword: _vm.isValidPassword
            },
            "validation-messages": {
              samePassword: 'Please enter the same password',
              isValidPassword: _vm.validPasswordMsg
            }
          },
          on: {
            "input": function($event) {
              _vm.validPassword = []
            }
          },
          model: {
            value: (_vm.passwordModel.new_password2),
            callback: function($$v) {
              _vm.$set(_vm.passwordModel, "new_password2", $$v)
            },
            expression: "passwordModel.new_password2"
          }
        }), _vm._v(" "), _c('FormulateInput', {
          attrs: {
            "type": "submit",
            "disabled": hasErrors,
            "label": "Change Password"
          }
        })]
      }
    }])
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e598bf58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/ProfileSettings.vue
// module id = 676
// module chunks = 0